module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              USER DETAILS\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n              User Email\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  })]), _vm._v("\n              Tick the permission required\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "admin",
      "value": "admin"
    },
    domProps: {
      "checked": Array.isArray(_vm.newUser.permission) ? _vm._i(_vm.newUser.permission, "admin") > -1 : (_vm.newUser.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newUser.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "admin",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newUser.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newUser.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newUser, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "admin"
    }
  }, [_vm._v("admin")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "role-editor",
      "value": "editor"
    },
    domProps: {
      "checked": Array.isArray(_vm.newUser.permission) ? _vm._i(_vm.newUser.permission, "editor") > -1 : (_vm.newUser.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newUser.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "editor",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newUser.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newUser.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newUser, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "role-editor"
    }
  }, [_vm._v("editor")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "podcast",
      "value": "podcast"
    },
    domProps: {
      "checked": Array.isArray(_vm.newUser.permission) ? _vm._i(_vm.newUser.permission, "podcast") > -1 : (_vm.newUser.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newUser.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "podcast",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newUser.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newUser.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newUser, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "podcast"
    }
  }, [_vm._v("podcast")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    attrs: {
      "type": "checkbox",
      "id": "video",
      "value": "video"
    },
    domProps: {
      "checked": Array.isArray(_vm.newUser.permission) ? _vm._i(_vm.newUser.permission, "video") > -1 : (_vm.newUser.permission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newUser.permission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "video",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newUser.permission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newUser.permission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newUser, "permission", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "video"
    }
  }, [_vm._v("video")])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.addNewUser
    }
  }, [_vm._v("\n                ADD USER\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25d3557b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalUser.vue
// module id = 632
// module chunks = 1